import React from 'react';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineDot from '@mui/lab/TimelineDot';
import {
  notEmptyString,
} from '@populateui/utils';
import {
  ClaimLogEntryViewDTO,
} from 'dtos';
import ActivityEntry, {
  ActivityEntryTitle,
} from 'pages/Dashboard/pages/Billing/ClaimForm/ClaimActivity/ActivityEntry';
import clsx from 'clsx';
import compact from 'lodash/compact';

type Props = {
  entries: ClaimLogEntryViewDTO[];
};

export default function ActivityEntryLogs({ entries }: Props) {
  return (
    <Timeline
      classes={{
        root: '!p-0 !m-0',
      }}
    >
      {entries.map((entry, index) => (
        <TimelineItem
          key={compact([
            String(index),
            entry.time,
            entry.triggerAction,
            entry.triggerActor,
          ]).filter(notEmptyString).join('-')}
          classes={{
            root: 'before:!flex-none before:!w-0 before:!p-0',
          }}
        >
          <TimelineOppositeContent
            classes={{
              root: '!flex !flex-none !h-5 !min-h-5 !w-20 !items-start !justify-end !px-0 !py-0 !pr-3',
            }}
          >
            <ActivityEntryTitle entry={entry} />
          </TimelineOppositeContent>
          <TimelineSeparator>
            <TimelineDot
              classes={{
                root: clsx('!mt-[5px] !mb-0 !shadow-none !p-0 !w-2.5 !h-2.5', {
                  '!bg-gray-300 !border-gray-300': index === 0,
                  '!bg-gray-100 !border-gray-300': index !== 0,
                }),
              }}
            />
            {index < entries.length - 1 && (
              <TimelineConnector
                classes={{
                  root: '!bg-gray-200',
                }}
              />
            )}
          </TimelineSeparator>
          <TimelineContent
            classes={{
              root: '!py-0 !px-3 !pb-3',
            }}
          >
            <ActivityEntry
              entry={entry}
              hideTitle
              className="pb-2"
            />
          </TimelineContent>
        </TimelineItem>
      ))}
    </Timeline>
  );
}
